import { render, staticRenderFns } from "./AdminTermsView.vue?vue&type=template&id=718bc07e"
import script from "./AdminTermsView.vue?vue&type=script&lang=ts"
export * from "./AdminTermsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports